module.exports = __webpack_public_path__ + "img/qk_pic.de44cad7.gif";